import { FANTASY } from '@/helpers/biwenger-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { Typography } from '@mui/material';

const JugadorAlineacionMercadoFantasy = ({
    value,
    fantasy,
    height = '20px',
    width = '20px',
    fontSize = 10,
    ...props
}) => {
    const formatedValue = toPriceInEuros(value);

    const getBackgroundColor = () => {
        let topRange = 0;
        let middleRange = 0;
        switch (fantasy) {
            case FANTASY.FANTASY:
                topRange = 1000000;
                middleRange = 0;
                break;
            case FANTASY.FANTASY_MARCA:
                topRange = 500000;
                middleRange = 0;
                break;
            case FANTASY.MISTER_FANTASY:
                topRange = 90000;
                middleRange = 0;
                break;
            case FANTASY.BIWENGER:
                topRange = 1000000;
                middleRange = 0;
                break;
        }
        if (value > topRange) {
            return '#1a5a8d';
        }
        if (value >= middleRange) {
            return '#206945 ';
        }

        if (!value || value === 0) {
            return '#202938';
        }

        return '#963c3c';
    };

    return (
        <>
            <Typography
                sx={{
                    background: getBackgroundColor(),
                    height: height,
                    width: width,
                    textAlign: 'center',
                    borderRadius: '4px',
                    color: '#fff',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    fontSize: fontSize,
                    position: 'relative',
                    ...props,
                }}
            >
                {formatedValue}
            </Typography>
        </>
    );
};

export default JugadorAlineacionMercadoFantasy;
